import { Reducer } from "redux";
import { AppActionKeys } from "./keys";
import { AppActionTypes } from "./types";
import { GenieActionKeys } from "store/genie/keys";
import { GenieActionTypes } from "store/genie/types";
import { NotificationCalloutDto } from "models/ApiModels";

//////////////////////////////////////////////////////////////////////////////////////

export interface AppState {
    readonly notifications: number;
    readonly callouts: NotificationCalloutDto[];
}

const initialState: AppState = {
    notifications: 0,
    callouts: []
};

//////////////////////////////////////////////////////////////////////////////////////

const appReducer: Reducer<AppState, AppActionTypes> = (state = initialState, action: AppActionTypes | GenieActionTypes) => {

    switch (action.type) {
        case GenieActionKeys.INIT:
            return { notifications: 0, callouts: [] };

        case AppActionKeys.NOTIFICATION:
            return { ...state, ...{ notifications: action.counter } };

        case AppActionKeys.CALLOUTS: {
            ///////////////////////////////
            // MERGE DE CALLOUTS 
            const newCallouts = state.callouts.slice(0);
            action.payload.forEach((v) => {
                const f = newCallouts.filter(p => p.feed == v.feed && p.topicId == v.topicId);
                if (f.length == 1) f[0].callout = v.callout;
                else newCallouts.push(v);
            });
            /////////////////////////////
            return { ...state, ...{ callouts: newCallouts } };
        }

        default:
            return state;
    }
};

export { appReducer };